import React from 'react'
import { generatePath } from 'react-router-dom'
import Home from 'portal/views/Home/Home'
import { RouterConfigItem } from 'portal/routes/types'


export const HomeRoute: RouterConfigItem = {
  path: '/',
  name: 'Home',
  title: '首页',
  render() {
    return (<Home />)
  },
  formatUrl() {
    return generatePath(this.path)
  },
}

export default [
  HomeRoute,
]
